import { observer } from 'mobx-react'
import { FC, useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { AmexHeaderLogo } from '@/assets/headers/amex-logo'
import { AmexHeaderLogoMobile } from '@/assets/headers/amex-logo-mobile'
import { EnpalHeaderLogo, EnpalHeaderLogoMobile } from '@/assets/headers/enpal-bank-logo'
import { ElavonHeaderLogo } from '@/assets/headers/elavon-header-logo'
import { scenarios } from '@constants/scenarios'
import { useKeyboardAwareViewport } from '@/hooks/useKeyboardAwareViewport'
import {
  STEPS_WITH_100_PERCENT_BRANDING,
  STEPS_WITHOUT_TOP_BAR,
  STEPS_WITHOUT_TOP_BAR_MOBILE,
} from './constants'
import { SignicatBrandingMobile } from '../SignicatBranding/SignicatBrandingMobile'
import './TopBar.css'
import { RaisinHeaderLogo, RaisinHeaderLogoMobile } from '@/assets/headers/raisin-header-logo'
import { BmwHeaderLogo } from '@/assets/headers/bmw-header-logo'
import {
  NordconceptHeaderLogo,
  NordconceptHeaderLogoMobile,
} from '@/assets/headers/nordconcept-header-logo'

export const TopBar: FC = observer(() => {
  const viewport = useKeyboardAwareViewport()

  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { currentScenarioId, currentPageIndex } = store.ScenarioState
  const currentStep = scenarios?.[currentScenarioId as keyof typeof scenarios]?.[currentPageIndex]
  const { themeId } = store.InterfaceState

  const [hideTopBar, setHideTopBar] = useState(false)

  useEffect(() => {
    setHideTopBar(
      STEPS_WITHOUT_TOP_BAR.includes(currentStep) ||
        (STEPS_WITHOUT_TOP_BAR_MOBILE.includes(currentStep) && isMobile)
    )
  }, [currentStep, isMobile])

  if (STEPS_WITH_100_PERCENT_BRANDING.includes(currentStep)) return <></>

  if (isMobile && viewport?.isKeyboardOpen && viewport?.keyboardHeight > 0) {
    return <></>
  }

  if (hideTopBar) return <></>

  if (themeId === 'amexTheme') {
    return (
      <header className="top-bar__header top-bar__header--amex">
        {isMobile ? <AmexHeaderLogoMobile /> : <AmexHeaderLogo />}
        <SignicatBrandingMobile />
      </header>
    )
  }

  if (themeId === 'bmwTheme') {
    return (
      <header className="top-bar__header top-bar__header--bmw">
        {!isMobile && <BmwHeaderLogo />}
        <SignicatBrandingMobile />
      </header>
    )
  }

  if (themeId === 'enpalTheme') {
    return (
      <header className="top-bar__header top-bar__header--enpal">
        {isMobile ? <EnpalHeaderLogoMobile /> : <EnpalHeaderLogo />}
        <SignicatBrandingMobile />
      </header>
    )
  }

  if (themeId === 'elavonTheme') {
    return (
      <header className="top-bar__header top-bar__header--elavon">
        <ElavonHeaderLogo />
        <SignicatBrandingMobile />
      </header>
    )
  }

  if (themeId === 'raisinTheme') {
    return (
      <header className="top-bar__header top-bar__header--raisin">
        {isMobile ? <RaisinHeaderLogoMobile /> : <RaisinHeaderLogo />}
        <SignicatBrandingMobile />
      </header>
    )
  }

  if (themeId === 'nordconceptTheme') {
    return (
      <header className="top-bar__header top-bar__header--nordconcept">
        {isMobile ? <NordconceptHeaderLogoMobile /> : <NordconceptHeaderLogo />}
        <SignicatBrandingMobile />
      </header>
    )
  }

  return <></>
})
